import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { getRequestInfo , resetInquires } from "../actions/inquires";
import { appointementInit } from "../actions/appointement";

const data = {
  wlName: "seat",
  locale : "fr",
  type : 1
}

class Home extends Component {
  constructor(props) {
    super(props);
    this.homeRedirection = this.homeRedirection.bind(this);
    this.extenRedirection = this.extenRedirection.bind(this);
  }
  homeRedirection(value, name) {
    //TRACKING
    var eventname = "";
    if(value=="demande"){
      eventname = "information-request"
    } else if(value=="achat") {
      eventname ="purchase-project"
    }
    var values = {"eventName":eventname}
    var iframeData = ["setData", values];
    console.log('iframeData :'+ iframeData );
    window.top.postMessage(iframeData , '*');

    this.props.resetInquires();
    this.props.getRequestInfo('home', value, name);
    this.props.appointementInit('GetServicesInformations' ,  data , 'dealers');
    console.log(values);
  }
  extenRedirection(url, track) {
    var values = {"eventName":track}
    var iframeData = ["setData", values];
    console.log('iframeData :'+ iframeData );
    window.top.postMessage(iframeData , '*');
    window.open(url , '_blank');
    console.log(values);
  }

  componentDidMount(){
    var iframeData = ['setVirtualPage', 'rdv-en-ligne/home'];
    console.log('iframeData :'+ iframeData );
    window.top.postMessage(iframeData , '*');


    /*(function (c, u) {
        var e = document.createElement('script');
        e.async = true;
        if(u.lastIndexOf('/', u.length - 1) !== u.length - 1)
        u = u + '/';
        u = u + 'dist/smartsignals2.js'; var d = '?'
        for (var p in c) {
        if(!c.hasOwnProperty(p)) continue;
        u = u + d + encodeURIComponent(p) + "=" + encodeURIComponent(c[p]); d = '&';
        }
        e.src = u;
        var t = document.getElementsByTagName('script')[0]; t.parentNode.insertBefore(e, t);
        })({
        scriptId: '<ZQyVcj5uSI9EeYpgNk8mN8E0PsPA3FK>', nativeEventTracking: true, xdmRecognition: true
        },'<https://smasi2-stage.smart-digital-solutions.de/>');*/
  }
  render() {
    return (
      <div>
        {this.props.restIntel.requesting ? (
          <div className="loader">
            <div className="loaderPicto" />
          </div>
        ) : null}
        <div className="homeContent">
          <div className="homeHeader">
            <div className="homeHeaderTxt fontBlack colorWhite">Contactez<br/>un conseiller
            <span className="baseline fontMedium">Prenez rendez-vous avec votre distributeur SEAT le plus proche.</span>
            </div>
          </div>
          <div className="homeCtaContent">
            <div className="halfContent">
              <div className="homeHeaderTxt_sub_left fontBlack">J’ai un projet d’achat
               </div>
              <div className="homeCta_1" onClick={() => this.extenRedirection('https://www.seat.fr/rdvenligne/rdv-distributeur-seat.html', 'customer-recontact')}>
                <div className="homeCtaTxt fontBold colorBlack">Prendre RDV avec mon distributeur SEAT</div>
              </div>
                <div className="homeCta_1" onClick={() => this.extenRedirection('https://www.dasweltauto.fr/fra/fr/occasions/seat/', 'used-vehicle')}>
                <div className="homeCtaTxt fontBold colorBlack">Je cherche une SEAT d’occasion</div>
              </div>
            </div>
            <div className="halfContent">
            <div className="homeHeaderTxt_sub_right fontBlack">Je suis client SEAT
               </div>
              <div className="homeCta_2" onClick={() => this.extenRedirection('https://www.seat.fr/entreprise/contact.html', 'customer-support-contact')}>
                <div className="homeCtaTxt fontBold colorBlack">Contacter le Service Client</div>
              </div>
              <div className="homeCta_2" onClick={() => this.extenRedirection('https://www.seat.fr/proprietaire/rdv-en-ligne.html?home_rdvatelier=ok', 'servicing-maintenance')}>
                <div className="homeCtaTxt fontBold colorBlack">Prendre rendez-vous en atelier
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getRequestInfo,
  appointementInit,
  resetInquires
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/containers/home.js